import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "../common/component/notification/notification.service";
import { SpecificProcessService } from "./specific-process.service";

@Component({
    selector: 'specific-process',
    templateUrl: './specific-process.component.html',
    styleUrls: ['./specific-process.component.scss']
})

export class SpecificProcessComponent implements OnInit {
    isLoadPanelVisible: boolean = false;
    specificProcess: any = {};
    specificProcesses: any[];
    constructor(private notificationService: NotificationService, private route: ActivatedRoute, private router: Router, private specificProcessService: SpecificProcessService) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params['id'] != null) {
                this.specificProcess.specificProcessId = Number(params['id']);

            }
        });

        this.getSpecificProcess();
    }

    getSpecificProcess() {
        this.isLoadPanelVisible = true;
        this.specificProcessService.getSpecificProcess().subscribe({
            next: specificProcesses => {
                this.specificProcesses = specificProcesses;
                if (this.specificProcess.specificProcessId) {
                    this.specificProcess.note = this.specificProcesses.find(x => x.specificProcessId == this.specificProcess.specificProcessId).note;
                }
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Specific Processes", error);
            }
        });
    }

    onSpecificProcessChange(event) {
        if (event.value) {
            this.specificProcess.note = this.specificProcesses.find(x => x.specificProcessId == event.value).note;
        } else {
            this.specificProcess.note = '';
        }
    }

    handleSubmit(e) {
        this.isLoadPanelVisible = true;

        if (this.specificProcess.specificProcessId) {
            this.specificProcessService.updateSpecificProcess(this.specificProcess).subscribe({
                next: specificProcesses => {
                    this.specificProcesses = specificProcesses;
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("success", "Updated Successfully", null);
                    window.self.close();
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while updating Specific Process", error);
                }
            });
        } else {
            this.specificProcess.specificProcessId = 0;
            this.specificProcessService.addSpecificProcess(this.specificProcess).subscribe({
                next: specificProcesses => {
                    this.specificProcesses = specificProcesses;
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("success", "Added Successfully", null);
                    window.self.close();
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while adding Specific Process", error);
                }
            });
        }
    }
}